/** @format */
import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { StudyRightCancellation, StudyRightPassivation } from 'common-typescript/types';
import { ModalService } from 'sis-common';

@Component({
    selector: 'sis-study-right-decision-modal',
    templateUrl: './study-right-decision-modal.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class StudyRightDecisionModalComponent {
    constructor(
        @Inject(ModalService.injectionToken) public values: StudyRightCancellation | StudyRightPassivation,
        public modal: NgbActiveModal,
    ) {}

    get isPassivation(): boolean {
        return !!(this.values as StudyRightPassivation)?.passivationType;
    }

    get passivation(): StudyRightPassivation {
        return this.values as StudyRightPassivation;
    }

    get cancellation(): StudyRightCancellation {
        return this.values as StudyRightCancellation;
    }
}
